export default __webpack_public_path__ + "static/media/mode_auto.5bf197f1.svg";